/**
 * Installs the router's `navigate` into the out-of-React navigation
 * bridge so `ide.*` platform-ops handlers (contacts handoff §2.5) can
 * switch pages from gateway-event dispatch. Renders nothing.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigator } from "@/lib/navigation-bridge";

export function NavigationBridgeInstaller() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator((path) => navigate(path));
    return () => setNavigator(null);
  }, [navigate]);
  return null;
}
